import styled from 'styled-components';

import { FlexBox, Text } from '@app/components/atoms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Container = styled(FlexBox)`
  width: 500px;
  padding: 44px 30px 47px;
  box-sizing: border-box;
  background: #ffffff;
  position: relative;

  @media screen and (max-width: 1024px) {
    width: 100%;
    padding: 32px 20px 40px;
  }
`;

export const CloseContainer = styled.div`
  position: absolute;
  top: 44px;
  right: 30px;
  cursor: pointer;
`;

export const CloseIcon = styled(FontAwesomeIcon)`
  font-size: 22px;
  color: #4f4f4f;
`;

export const TitleWrapper = styled(FlexBox)`
  margin-bottom: 32px;
  gap: 9px;
`;

export const TitleIcon = styled(FontAwesomeIcon)`
  font-size: 20px;
  color: #4f4f4f;
`;

export const Title = styled(Text)`
  font-weight: 500;
`;

export const SearchTitleWrapper = styled(FlexBox)`
  width: 100%;
`;

export const SearchTitleContainer = styled(FlexBox)``;

export const SearchTitle = styled(Text)`
  font-weight: 500;
  line-height: 33px;
  margin-bottom: 2px;
`;

export const SearchSubtitle = styled(Text)`
  font-weight: 400;
  line-height: 14px;
  margin-bottom: 16px;
`;

export const PriceSliderWrapper = styled.div`
  width: 100%;
  margin-bottom: 37px;
`;

export const BedsBathsWrapper = styled(FlexBox)`
  width: 100%;
  gap: 14px;
  margin-bottom: 24px;
`;

export const Label = styled(Text)<{ hasMarginTop?: boolean }>`
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 12px;

  margin-top: ${({ hasMarginTop }) => (hasMarginTop ? '21px' : '0')};
`;

export const TypeFiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  row-gap: 18px;
  column-gap: 16px;
  margin-bottom: 24px;
`;

export const SearchCityWrapper = styled.div`
  width: 100%;
  margin-bottom: 36px;
`;

export const BuyButtonWrapper = styled.div<{ selected: boolean }>`
  border: ${({ selected }) =>
    selected ? '1px solid #D47E5B' : '1px solid #D9D9D9'};
  border-radius: 6px;
`;

export const BuyButton = styled.div<{ selected: boolean; disable?: boolean }>`
  background: #ffffff;
  border: ${({ selected }) =>
    selected ? '1px solid #D47E5B' : '1px solid transparent'};
  border-radius: 5px;
  padding: 12px 10px;
  box-sizing: border-box;
  cursor: pointer;

  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #4f4f4f;
`;

export const SectionTitle = styled(Text)`
  font-weight: 500;
  line-height: 33px;
  margin-top: 42px;
  margin-bottom: 1px;
`;

export const SectionSubtitle = styled(Text)`
  font-weight: 400;
  line-height: 14px;
  margin-bottom: 38px;
`;

export const Row = styled(FlexBox)`
  gap: 17px;

  @media screen and (max-width: 1024px) {
    width: 100%;
    flex-direction: column;
    gap: 20px;
  }
`;

export const InputContainer = styled.div<{ bigger?: boolean }>`
  width: 185px;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const GarageContainer = styled.div`
  margin-top: 27px;
`;

export const AddressesContainer = styled(FlexBox)`
  width: 100%;
  margin-top: 27px;
  gap: 25px;
`;

export const ErrorWrapper = styled.div`
  width: 100%;
  margin-top: 35px;
`;

export const TextareaContainer = styled(FlexBox)`
  background: #ffffff;
  border: 1px solid #c6c6c6;
  border-radius: 5px;
  height: 264px;
  width: 100%;
  margin-top: 21px;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    height: 150px;
  }
`;

export const InsideContainer = styled(FlexBox)`
  width: 100%;
  padding: 15px 17px 0 14px;
  box-sizing: border-box;
`;

export const TextIconWrapper = styled(FlexBox)`
  gap: 9px;
`;

export const InsideTitleIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  color: #4f4f4f;
`;

export const InsideTitle = styled(Text)`
  font-weight: 600;
`;

export const VisibleTextIcon = styled(FontAwesomeIcon)`
  font-size: 12px;
  color: #888888;
`;

export const VisibleText = styled(Text)`
  font-weight: 400;
`;

export const Textarea = styled.textarea`
  height: 100%;
  width: 100%;
  resize: none;
  outline: none;
  border: none;
  padding: 16px;
  box-sizing: border-box;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #4f4f4f;

  &::placeholder {
    color: #888888;
    font-weight: 400;
  }
`;

export const ButtonsContainer = styled(FlexBox)`
  width: 100%;
  margin-top: 13px;
`;

export const RequiredWrapper = styled(FlexBox)`
  width: 100%;
  margin-top: 21px;
`;

export const RequiredText = styled(Text)`
  span {
    font-weight: 600;
    font-size: 14px;
    color: #d47e5b;
  }
`;

export const SkipContainer = styled(FlexBox)`
  width: 100%;
  margin-top: 13px;
`;

export const SkipButton = styled(Text)`
  font-weight: 400;
  cursor: pointer;
  user-select: none;
`;

export const ClientNotesTitleWrapper = styled(FlexBox)`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 12px;
  gap: 10px;
`;

export const ClientNotesIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  color: #4f4f4f;
`;

export const ClientNotesText = styled(Text)`
  font-weight: 400;
`;
